var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"my-modal top p-b",attrs:{"title":"其他加扣款","width":"800","mask-closable":false,"footer-hide":true},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"table-box"},[_c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.tableData,"row-key":"id"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }